import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REQUEST } from "../..";
import {
  contentAPI,
  cancelPlanAPI,
  createOfferEndPointURL,
  fetchAllCoachOfferEndPointURL,
  getAllCoachListEndPointURL,
  deleteAccountAPI,
  getCoachProfileDataEndPointURL,
  changePasswordAPI,
  disableAccountAPI,
  getSubscriptionDataAPI,
  updateCoachProfileDataEndPointURL,
  updateCoachProfileExtendedEndPointURL,
  coachingDashboardAPI,
  fetchWorkshopDetailsByIdEndPointURL,
  fetchWebinarDetailsByIdEndPointURL,
  fetchNuterraDetailsByIdEndPointUR,
} from "../../../../routes/apiurls";

export const fetchCoachList = createAsyncThunk(
  "fetch-coach-list",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: getAllCoachListEndPointURL,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchCoachSubscription = createAsyncThunk(
  "fetch-coach-subscription",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: getSubscriptionDataAPI,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchCoachProfileData = createAsyncThunk(
  "fetch-coach-profile",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: getCoachProfileDataEndPointURL,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const authChangePassword = createAsyncThunk(
  "auth-change-password",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: changePasswordAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const coachDisableAccount = createAsyncThunk(
  "coach-account-disable",
  async (props) => {
    const { callback } = props;
    try {
      const response = await API_REQUEST({
        url: disableAccountAPI,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const coachDeleteAccount = createAsyncThunk(
  "coach-account-delete",
  async (props) => {
    const { callback } = props;
    try {
      const response = await API_REQUEST({
        url: deleteAccountAPI,
        method: "DELETE",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const coachPlanCancel = createAsyncThunk(
  "coach-plan-cancel",
  async (props) => {
    const { callback } = props;
    try {
      const response = await API_REQUEST({
        url: cancelPlanAPI,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const updateProfile = createAsyncThunk(
  "coach-profile-update",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateCoachProfileDataEndPointURL,
        data: payload,
        method: "PATCH",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const updateCoachProfileExtended = createAsyncThunk(
  "coach-profile-update-extended",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: updateCoachProfileExtendedEndPointURL,
        data: payload,
        method: "PATCH",
        headers: { "Content-Type": "multipart/form-data" },
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const coachCreateOffer = createAsyncThunk(
  "coach-create-offer",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: createOfferEndPointURL,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const editOffer = createAsyncThunk(
  "edit-offer",
  async (props) => {
    const { payload, callback, id } = props;
    try {
      const response = await API_REQUEST({
        url: createOfferEndPointURL + `/${id}`,
        method: "PATCH",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const fetchAllCoachOffers = createAsyncThunk(
  "fetch-all-coach-offers",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: fetchAllCoachOfferEndPointURL,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchContent = createAsyncThunk("fetch-content", async () => {
  try {
    const response = await API_REQUEST({
      url: contentAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) { }
});

export const createContent = createAsyncThunk(
  "create-content",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: contentAPI,
        data: payload,
        method: "POST",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const coachDeleteContent = createAsyncThunk(
  "coach-account-content",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: contentAPI + `/${payload}`,
        method: "DELETE",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const editContent = createAsyncThunk(
  "edit-content",
  async (props) => {
    const { payload, id, callback } = props;
    try {
      const response = await API_REQUEST({
        url: contentAPI + `/${id}`,
        data: payload,
        method: "PATCH",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);

export const deleteOffer = createAsyncThunk(
  "delete-offer",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: createOfferEndPointURL + `/${payload}`,
        method: "DELETE",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  }
);


export const fetchCoachingDashboard = createAsyncThunk("fetch-coaching-dashboard", async () => {
  try {
    const response = await API_REQUEST({
      url: coachingDashboardAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) { }
});

export const fetchWorkshopeDetailsById = createAsyncThunk("fetch-workshop-details-by-id", async (props) => {
  try {
    const { payload } = props;
    const response = await API_REQUEST({
      url: `${fetchWorkshopDetailsByIdEndPointURL}${payload}`,
      method: "GET",
      isSuccessToast: false,
      isErrorToast: false,
    });
    return response;
  } catch (error) { }
});

export const fetchWebinarDetailsById = createAsyncThunk("fetch-webinar-details-by-id", async (props) => {
  try {
    const { payload } = props;
    const response = await API_REQUEST({
      url: `${fetchWebinarDetailsByIdEndPointURL}${payload}`,
      method: "GET",
      isSuccessToast: false,
      isErrorToast: false,
    });
    return response;
  } catch (error) { }
});

export const fetchNuterraDetailsById = createAsyncThunk("fetch-nuterra-details-by-id", async (props) => {
  try {
    const { payload } = props;
    const response = await API_REQUEST({
      url: `${fetchNuterraDetailsByIdEndPointUR}${payload}`,
      method: "GET",
      isSuccessToast: false,
      isErrorToast: false,
    });
    return response;
  } catch (error) { }
});
